<template>
  <div>
    <router-link
      v-if="child.isShow && child.href"
      :to="child.href"
      tag="a"
      active-class="a--active"
      exact>
      <div class="sidemenu-container">
        <span v-if="child.icon">
          <i
            :class="getMenuIcon"
            aria-hidden="true"/>
        </span>
        <span v-else>
          <img
            v-if="ishrefEqualToRoute(child.href) && child.iconUrlActive"
            :src="child.iconUrlActive"
            class="left-icon-url">
          <img
            v-else-if="child.iconUrlNotActive"
            :src="child.iconUrlNotActive"
            class="left-icon-url">
        </span>
        <span class="nav-text toggleable">  {{ child.name }} </span>
      </div>
    </router-link>

    <div
      v-else-if="child.isShow && child.hrefout"
      :class="{ 'div--active': ishrefoutEqualToWindowLocation(child.hrefout) }">
      <a :href="child.hrefout">
        <div class="sidemenu-container">
          <span v-if="child.icon">
            <i
              :class="getMenuIcon"
              aria-hidden="true"/>
          </span>
          <span v-else>
            <img
              v-if="ishrefoutEqualToWindowLocation(child.hrefout) && child.iconUrlActive"
              :src="child.iconUrlActive"
              class="left-icon-url">
            <img
              v-else-if="child.iconUrlNotActive"
              :src="child.iconUrlNotActive"
              class="left-icon-url">
          </span>
          <span class="nav-text toggleable">  {{ child.name }} </span>
        </div>
      </a>
    </div>

  </div>
</template>

<script>
/* eslint-disable vue/require-default-prop */
/* eslint linebreak-style: ["error", "windows"] */
export default {
  name: 'JNestedMenuUnit',
  props: {
    child: Object,
  },
  computed: {
    getMenuIcon() {
      return `fa fa-${this.child.icon} left-icon`;
    },
  },
  methods: {
    ishrefEqualToRoute(href) {
      return this.$route.path === href;
    },
    ishrefoutEqualToWindowLocation(hrefout) {
      return window.location.href === hrefout;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/layouts/sidebar/jNestedMenuUnit.vue